import moment from 'moment';

export default function humanizeDuration(toDate, fromDate = moment()) {
    let compareTo = toDate;
    if (typeof toDate === 'string') {
        compareTo = moment(toDate);
    }
    return moment.duration(compareTo.diff(fromDate)).humanize();
}
